/* eslint-disable no-unused-expressions */
import { Stack } from '@mui/material';
import Typography from '@mui/material/Typography';
import { useLocation, useNavigate } from 'react-router-dom';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import useCreate from '../../../utils/hooks/crud-hooks/useCreate';
import CustomButton from '../../../components/button/CustomButton';

const ActivateAccountSection = () => {
  const navigate = useNavigate();
  const { search } = useLocation();
  const queryParams = new URLSearchParams(search);
  const token = queryParams.get('token');

  const { mutate, isLoading } = useCreate<Record<string, unknown>, string>({
    resource: `/auth/activate?token=${token}`,
  });
  const { t } = useTranslation();
  const [validated, setValidated] = useState<boolean>(false);

  useEffect(() => {
    if (token) {
      mutate(token, {
        onSuccess: () => {
          setValidated(true);
        },
        onError: () => {
          setValidated(false);
        },
      });
    }
  }, [token]);

  return (
    <Stack width="100%" spacing={3}>
      {validated ? (
        <>
          <Typography
            variant="headline1"
            sx={{
              color: 'primaryDark.600',
            }}
          >
            {t('register.verificationSuccessful')}
          </Typography>

          <Typography
            variant="body2"
            sx={{
              color: 'primaryDark.600',
            }}
          >
            {t('register.loginToCompleteYourAccountCreation')}
          </Typography>

          <CustomButton
            onClick={() => navigate('/login')}
            sx={{
              maxWidth: 'fit-content',
              mt: 2,
              alignSelf: { xs: 'start', md: 'end' },
            }}
          >
            {t('common.continue')}
          </CustomButton>
        </>
      ) : (
        <>
          <Typography
            variant="headline1"
            sx={{
              color: 'primaryDark.600',
            }}
          >
            {t('register.sorryVerificationFailed')}
          </Typography>

          <Typography
            variant="body2"
            sx={{
              color: 'primaryDark.600',
            }}
          >
            {t('register.emailVerificationRequestNewVerificationEmail')}
          </Typography>
        </>
      )}
    </Stack>
  );
};

export default ActivateAccountSection;
